import axios from 'axios';

export default axios.create({
    baseURL:'https://api.jsonbin.io/b/5fe441edc8f3567b4a1dcd18/2'
});